import * as React from "react";
import { AuthProvider } from "./common/contexts/AuthContext";
import { AppContent } from "./AppContent";
import "@patternfly/react-core/dist/styles/base.css";
import "./App.css";
import "./components/CategorySelectionComponent.css";

// Example: branding config per tenant
const BRANDINGS = {
  default: {
    "--brand-primary": "#1f4650",
    "--brand-secondary": "#54B8DF",
    "--brand-accent": "#46DADF",
    "--brand-text": "#FFFFFF",
    "--brand-white": "#FFFFFF",
    "--selected-background": "#e6f7fa",
    "--box-shadow": "",
    "--brand-gradient": "linear-gradient(135deg, #54DADF 0%, #EBF982 100%)",
    "--brand-logo": "Altron Logo - Light 2x.png",
  },
  netstar: {
    "--brand-primary": "#140047", //primary
    "--brand-secondary": "#d9fcba", //secondary (buttons, highlights)
    "--brand-accent": "#FF9900",
    "--brand-text": "#000000",
    "--brand-white": "#FFFFFF",
    "--selected-background": "#f0f0f0",
    "--brand-gradient": "linear-gradient(45deg, #bf90f7 0%, #4f33eb 100%)",
    "--brand-logo": "netstar logo-02.png",
  },
  AltronDigitalBusiness: {
    "--brand-primary": "#1f4650",
    "--brand-secondary": "#54B8DF",
    "--brand-accent": "#46DADF",
    "--brand-text": "#FFFFFF",
    "--brand-white": "#FFFFFF",
    "--selected-background": "#e6f7fa",
    "--box-shadow": "",
    "--brand-gradient": "linear-gradient(135deg, #54DADF 0%, #EBF982 100%)",
  },
};

function getTenantFromSubdomain() {
  const host = window.location.hostname;
  const parts = host.split(".");
  // Assumes subdomain.tenant.com or subdomain.tenant.local

  // tenant.localhost.com
  // tenantB.localhost.com
  if (parts.length >  2) {
    return parts[0].toLowerCase();
  }
  return "default";
}

function setBranding(branding) {
  Object.entries(branding).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
}

export default function App() {
  
  React.useEffect(() => {
    const tenant = getTenantFromSubdomain();
    console.log("Here is the tennant", tenant);
    setBranding(BRANDINGS[tenant] || BRANDINGS.default);
  }, []);

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
